import { render } from "./BookAWorkshop.vue?vue&type=template&id=21a39c66"
import script from "./BookAWorkshop.vue?vue&type=script&lang=js"
export * from "./BookAWorkshop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__